import UsagePing from './UsagePing';

export default UsagePing;
